var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp-order-steps"},_vm._l((_vm.total),function(index){return _c('div',{key:index,staticClass:"sp-order-steps__step",class:{
      'sp-order-steps__step--active': _vm.currentStep >= Number(index),
      'sp-order-steps__step--done':
        _vm.currentStep > Number(index) ||
        (Number(index) === _vm.currentStep && _vm.isCurrentStepCompleted)
    }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }